"use client";

import { cn } from "../../../../../../lib/utils";
// import { useLoopItem } from "../../../providers/loop/ui-loop-context";
import { useSlugNodeClassName } from "../../utils/use-slug-node-class";
import { buildClassNameFromProps } from "../../utils/class-tokens";

const TYPOGRAPHY_CLASS_PROPS = [
    "color",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "align",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "whitespace",
];

function resolveLinkHref(linkType, href) {
    const value = href?.trim() ?? "";

    if (!value) {
        return "";
    }

    if (linkType === "email") {
        return value.startsWith("mailto:") ? value : `mailto:${value}`;
    }

    if (linkType === "phone") {
        return value.startsWith("tel:") ? value : `tel:${value}`;
    }

    if (linkType === "anchor") {
        return value.startsWith("#") ? value : `#${value.replace(/^#+/, "")}`;
    }

    if (/^(https?:\/\/|\/|#|mailto:|tel:)/i.test(value)) {
        return value;
    }

    return `https://${value}`;
}

export default function Typography({
    color,
    fontFamily,
    fontSize,
    fontWeight,
    align,
    marginRight,
    marginLeft,
    marginTop,
    marginBottom,
    paddingRight,
    paddingLeft,
    paddingTop,
    paddingBottom,
    useRuntime,
    field,
    type,
    options,
    isLink,
    linkType,
    href,
    target,
    linkMode,
    textBefore,
    linkText,
    textAfter,
    whitespace,
    ...props
}) {

    let content = props.text;

    const typographyProps = {
        color,
        fontFamily,
        fontSize,
        fontWeight,
        align,
        marginRight,
        marginLeft,
        marginTop,
        marginBottom,
        paddingRight,
        paddingLeft,
        paddingTop,
        paddingBottom,
        whitespace: props.whitespace,
        responsive: props.responsive,
    };
    const nodeClassName = useSlugNodeClassName();
    const className = cn(
        nodeClassName,
        "transition duration-300 ease-in-out",
        buildClassNameFromProps(typographyProps, TYPOGRAPHY_CLASS_PROPS)
    );
    const Tag = type || "p";
    const resolvedHref = resolveLinkHref(linkType, href);
    const rel = target === "_blank" ? "noopener noreferrer" : undefined;
    const partialLinkText = linkText || content;

    const renderContent = () => {
        if (!isLink || !resolvedHref) {
            return content;
        }

        if (linkMode === "partial") {
            return (
                <>
                    {textBefore}
                    <a href={resolvedHref} target={target || "_self"} rel={rel} className="underline-offset-4 hover:underline">
                        {partialLinkText}
                    </a>
                    {textAfter}
                </>
            );
        }

        return (
            <a href={resolvedHref} target={target || "_self"} rel={rel} className="underline-offset-4 hover:underline">
                {content}
            </a>
        );
    };

    return (
        <Tag className={className}>
            {renderContent()}
        </Tag>
    );
}

Typography.craft = {
    props: {
        text: "Editable text",
        color: "text-black",
        fontFamily: "font-roboto",
        fontSize: "text-base",
        align: "text-start",
        fontWeight: "font-normal",
        field: "",
        type: "p",
        useRuntime: false,
        options: [],
        isLink: false,
        linkType: "url",
        href: "",
        target: "_self",
        linkMode: "full",
        textBefore: "",
        linkText: "",
        textAfter: "",
        paddingTop: "",
        paddingRight: "",
        paddingBottom: "",
        paddingLeft: "",
        marginTop: "",
        marginRight: "",
        marginBottom: "",
        marginLeft: "",
        paddingLocked: true,
        marginLocked: true,
        whitespace: "whitespace-normal",
    },
};
